import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from '../../../../../modules/google-analytics/google-analytics.service';
import { CommonService } from '../../../../../common/services/common.service';
import { RouterConstants } from '../../../../../core/routing/constants/app-paths.constant';
import { ForgotPasswordConstants } from '../../constants/forgot-password.constant';

@Component({
  selector: 'iposcen-reset-pwd',
  templateUrl: './reset-pwd.component.html',
  styleUrls: ['./reset-pwd.component.scss']
})
export class ResetPwdComponent implements OnInit {
  modalTitle: string;
  modalBody: string;
  href: string;
  direction: string;

  constructor(private router: Router, 
    private cmnService: CommonService,
    private googleAnalyticsService:GoogleAnalyticsService) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.router.navigate([RouterConstants.LOGIN_PAGE_LINK]);
    }, ForgotPasswordConstants.AUTO_CLOSING_SECONDS);
    this.direction = this.cmnService.direction;
    this.href = RouterConstants.LOGIN_PAGE_LINK;
    this.modalTitle = ForgotPasswordConstants.RESET_PWD_MODAL_TITLE;
    //gtm(Google tag manager)
    window['dataLayer'].push({
      'reset_password':true
      });
    this.googleAnalyticsService.resetPaswordSuccessful();
  }

  close(): void {
    this.router.navigate([RouterConstants.LOGIN_PAGE_LINK]);
  }

}
